import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';

import { useSite } from '../../hooks/use-site';
import { getLocaleConfig } from '../../helpers/locale-helper';

interface LanguageValidatorProps {
  children: React.ReactNode;
}

const VALID_REGIONS = ['eu', 'uk', 'us'];

export default function LanguageValidator({ children }: LanguageValidatorProps) {
  const { language, region } = useParams();
  const { theme } = useSite();
  const location = useLocation();

  const host = window.location.hostname;
  const { validLocales, defaultLocale } = getLocaleConfig(host, theme);

  // Validate region if present (only for Self-Co paths)
  if (region && !VALID_REGIONS.includes(region)) {
    const newPath = location.pathname.replace(`/${region}`, '/eu') + location.search;

    return <Navigate to={newPath} replace />;
  }

  // If language param exists but is invalid for this domain, redirect to default locale
  if (language && !validLocales.includes(language)) {
    const newPath = location.pathname.replace(`/${language}`, `/${defaultLocale}`) + location.search;

    return <Navigate to={newPath} replace />;
  }

  return children as React.ReactElement;
}
